// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qaBD","content":"styles_content__1O3hy"};